// extracted by css-extract-rspack-plugin
export default {"root":"root-AWrFFy","label":"label-pZFfoy","input":"input-JJBhjR"};